/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }

    return [year, month, day].join('-');
}

var loadYoutubePlayer = function(playerId) {
    if (!document.getElementById(playerId)) {
        return;
    }
    var tag = document.createElement('script');

    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    // <iframe src="https://www.youtube.com/embed/<?= $videoId ?>?rel=0&amp;controls=0&amp;showinfo=1&amp;autoplay=1&amp;loop=1&amp;mute=1&amp;playlist=<?= $videoId ?>&amp;modestbranding=1" frameborder="0" allowfullscreen></iframe>  -->

    var player;
    window.onYouTubeIframeAPIReady = function() {
        player = new YT.Player('youtube-player', {
            height: '390',
            width: '640',
            videoId: document.getElementById(playerId).getAttribute('data-id'),
            playerVars: {
                autoplay: 1,
                controls: 0,
                rel: 0,
                fs: 0,
                mute: 1,
                modestbranding: 1,
                playsinline: 1
            },
            events: {
                onReady: function(e) {
                    // On mobile playback does not start without user action
                    if (player.getPlayerState() === YT.PlayerState.CUED) {
                        jQuery('#' + playerId).parents('.header-bg-container').addClass('show-playbutton enable-iframe-interaction');
                    }
                },
                onStateChange: function(e) {
                    if (e.data === YT.PlayerState.BUFFERING) {
                        jQuery('.show-playbutton').removeClass('show-playbutton');
                    }
                    if (e.data === YT.PlayerState.PLAYING) {
                        jQuery('#' + playerId).fadeIn(1000).addClass('show-player');
                        jQuery('.show-playbutton').removeClass('show-playbutton');
                    }
                    if (e.data === YT.PlayerState.ENDED) {
                        player.playVideo();
                    }
                }
            }
        });
    };
};

function throttle(fn, threshhold, scope) {
    threshhold = threshhold || (threshhold = 250);
    var last,
        deferTimer;
    return function() {
        var context = scope || this;

        var now = +new Date(),
            args = arguments;
        if (last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function() {
                last = now;
                fn.apply(context, args);
            }, threshhold);
        } else {
            last = now;
            fn.apply(context, args);
        }
    };
}

function addPropertyValidation() {
    if (!jQuery('#add-property').length) {
        return;
    }

    //jQuery('#autocomplete').attr('placeholder', jQuery('#autocomplete').data('placeholder')); // fool Chrome autocomplete
    var isEmail = function() {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(jQuery('input[type="email"]').val());
    };
    var isLocation = function() {
        return jQuery('#country').val() !== "";
    };
    var validateEmail = function(e) {
        var isValidEmail = isEmail();
        if (e && e.type === 'keypress') {
            if (isValidEmail) {
                jQuery('.email .error-message').hide();
            }
        } else {
            jQuery('.email .error-message').toggle(!isValidEmail);
        }
    };
    var validateLocation = function() {
        //window.setTimeout(function() {
        jQuery('.location .error-message').toggle(!isLocation());
        //}, 300);
    };

    jQuery('#autocomplete').on('keypress', function() {
        jQuery('#route, #location_array').val('');
    });
    jQuery('input[type="email"]').on('keypress blur', validateEmail);
    var maxRooms = 15,
        $roomsTotal = jQuery('input[name="rooms"]');
    jQuery('.plus-room').click(function() {
        if ($roomsTotal.val() < maxRooms) {
            $roomsTotal.val(parseInt($roomsTotal.val()) + 1);
        }
    });
    jQuery('.min-room').click(function() {
        if ($roomsTotal.val() > 1) {
            $roomsTotal.val(parseInt($roomsTotal.val()) - 1);
        }
    });
    $roomsTotal.blur(function() {
        entry = parseInt($roomsTotal.val());
        window.console.log(entry);
        if (entry < 1 || !entry) {
            $roomsTotal.val(1);
        }
        if (entry > maxRooms) {
            $roomsTotal.val(maxRooms);
        }
    });

    jQuery('#add-property').submit(function() {
        validateLocation();
        validateEmail();
        if (!isEmail() || !isLocation()) {
            return false;
        }
        if (jQuery('#route').val() === '') {
            jQuery('#add-property').attr('action', jQuery('#add-property').data('action-location'));
        }
    });
}

/* Google Places autocompleter */
var placeSearch, autocomplete;
var componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name'
};

function fillInAddress() {
    // Get the place details from the autocomplete object.
    var place = autocomplete.getPlace();

    document.getElementById('country').value = '';
    document.getElementById('route').value = '';

    // Get each component of the address from the place details
    // and fill the corresponding field on the form.
    var address = {};
    var addressText = [];
    for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (componentForm[addressType]) {
            var val = place.address_components[i][componentForm[addressType]];
            address[addressType] = val;
            addressText.push(addressType + ': ' + val);
            if (addressType === 'country') {
                document.getElementById('country').value = val;
            }
            if (addressType === 'route') {
                document.getElementById('route').value = val;
            }
        }
    }
    address.lat = place.geometry.location.lat();
    address.lng = place.geometry.location.lng();
    addressText.push('lat: ' + address.lat);
    addressText.push('lng: ' + address.lng);

    document.getElementById('location_json').value = JSON.stringify(address);
    document.getElementById('location_array').value = addressText.join("\n");

    jQuery('.location .error-message').toggle(jQuery('#country').val() === '');
}

function initAutocomplete() {
    // Create the autocomplete object, restricting the search to geographical
    // location types.
    var params = {
        types: ['geocode']
    }; // , componentRestrictions: {country:'eg'}
    // if (window.locationCountry) {
    //   params.componentRestrictions = { country: window.locationCountry };
    // }  
    if (window.locationArea) {
        //params['locationbias'] = 'rectangle:'+window.locationArea.lat2+','+window.locationArea.lng1+'|'+window.locationArea.lat1+','+window.locationArea.lng2;
        var defaultBounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(window.locationArea.lat2, window.locationArea.lng1),
            new google.maps.LatLng(window.locationArea.lat1, window.locationArea.lng2));
        params.bounds = defaultBounds;
    }

    autocomplete = new google.maps.places.Autocomplete(
        /** @type {!HTMLInputElement} */
        (document.getElementById('autocomplete')),
        params); // address = only streets, but fails in arabic countries

    // When the user selects an address from the dropdown, populate the address
    // fields in the form.
    // if (window.locationCountry) {
    //   autocomplete.setComponentRestrictions({'country': [ window.locationCountry ]});
    // }

    autocomplete.addListener('place_changed', fillInAddress);
}

// Bias the autocomplete object to the user's geographical location,
// as supplied by the browser's 'navigator.geolocation' object.
function geolocate() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
            var geolocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            var circle = new google.maps.Circle({
                center: geolocation,
                radius: position.coords.accuracy
            });
            autocomplete.setBounds(circle.getBounds());
        });
    }
}

// map pin
function initLocationPicker() {
    var mapOptions = {
        zoom: 15
    };
    if (location_json && location_json.lat && location_json.lng) {
        mapOptions.center = {
            lat: location_json.lat,
            lng: location_json.lng
        };
        setCurrentPosition = false;
    } else {
        setCurrentPosition = true;
    }
    var locationPicker = new window.locationPicker('location-picker-map', {
        setCurrentPosition: setCurrentPosition, // You can omit this, defaults to true
    }, mapOptions);

    google.maps.event.addListener(locationPicker.map, 'idle', function(event) {
        // Get current location and show it in HTML
        var picker = locationPicker.getMarkerPosition();
        location_json.lat = picker.lat;
        location_json.lng = picker.lng;
        var addressText = [];
        for (var addressType in location_json) {
            addressText.push(addressType + ': ' + location_json[addressType]);
        }
        // document.getElementById('location_json').value = JSON.stringify(address);
        document.getElementById('location_array').value = addressText.join("\n");

    });

}

// validates price estimation response
function validateResponse(response) {
    if (response.response.adrLtm === null || response.response.adrLtm < 1 || response.response.hasOwnProperty('error') || (response.response.hasOwnProperty('status') && response.response.status === "error")) {
        return false;

    }
    return true;
}

// format parameters
function formatParams(params) {
    return "?" + Object.keys(params).map(function(key) {
        return key + "=" + encodeURIComponent(params[key]);
    }).join("&");
}

function storeEstimatedPricesForEmailTemplate(response, preselectedCurrency) {
    if (preselectedCurrency !== 'usd') {
        // inject the prices on the form fields so you can send them by email
        document.getElementById('dailyPrice').value = response.response.currencies[preselectedCurrency].adrLtm_converted.currencySymbol + "" + parseFloat(response.response.currencies[preselectedCurrency].adrLtm_converted.convertedAmount).toFixed(0);
        document.getElementById('weeklyPrice').value = response.response.currencies[preselectedCurrency].adrLtm_converted.currencySymbol + "" + parseFloat(response.response.currencies[preselectedCurrency].adrLtm_converted.convertedAmount).toFixed(0) * 7;
        document.getElementById('monthlyPrice').value = response.response.currencies[preselectedCurrency].adrLtm_converted.currencySymbol + "" + (parseFloat(response.response.currencies[preselectedCurrency].adrLtm_converted.convertedAmount).toFixed(0) * 30.4167).toFixed(0);

    } else {
        document.getElementById('dailyPrice').value = "$ " + parseFloat(response.response.adrLtm).toFixed(0);
        document.getElementById('weeklyPrice').value = "$ " + parseFloat(response.response.adrLtm).toFixed(0) * 7;
        document.getElementById('monthlyPrice').value = "$ " + (parseFloat(response.response.adrLtm).toFixed(0) * 30.4167).toFixed(0);

    }
}

function showNonCoveredAreaMessage() {
    var div = document.getElementById("price-calc");
    var h2 = document.createElement("p");
    h2.innerHTML = "We don't have coverage for your area. This means that we cannot estimate your average income.";
    div.appendChild(h2);
}


function processNonCoveredArea(locationArr) {
    var countryFallback = {
        'Tunisia': '36.7776766,10.1185238',
        'Egypt': '29.8668708,31.3130815',
        'Cyprus': '35.119091,33.3856133',
        'Dubai - United Arab Emirates': '25.1139855,55.397374',
        'Abu Dhabi - United Arab Emirates': '24.4198189,54.4350803'
    };

    for (var i in locationArr) {
        var elementArray = locationArr[i].split(": ");

        if (elementArray[0] === "country" &&
           (elementArray[1] !== "United Arab Emirates" || (elementArray[0] === "locality") &&
                (elementArray[1] === "Abu Dhabi" || elementArray[1] === "Dubai"))) {

            if (countryFallback.hasOwnProperty(elementArray[1])) {

                var parameters = {
                    'address': countryFallback[elementArray[1]],
                    'nrBedrooms': parseInt(document.querySelector('[name=rooms]').value),
                    'nrBathrooms': 1,
                    'nrPeople': 2,
                    'currency': 'gbp',
                    'markup': markup
                };
                var xmlhttp = new XMLHttpRequest();
                xmlhttp.open("GET", (location.host === 'localhost' ? '/airbetter/' : '') + "/php/priceEstimator.php" + formatParams(parameters));
                xmlhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                xmlhttp.send();
                xmlhttp.onreadystatechange = function() {
                    if (this.readyState === 4 && this.status === 200) {
                        var response = JSON.parse(this.responseText);
                        var booleanValidation = validateResponse(response);

                        if (!booleanValidation) {
                            showNonCoveredAreaMessage();

                        } else {
                            processPriceEstimation(response);
                        }
                    }
                };
                break;
            } else {
                showNonCoveredAreaMessage();
            }
        }
    }
}

function returnCalculatedPrice(periodSelection, amount) {
    amount = parseFloat(amount);
    if (periodSelection === 0) { // day
        return amount.toFixed(0);

    } else if (periodSelection === 1) { // week
        return amount.toFixed(0) * 7;

    } else if (periodSelection === 2) { // month
        return (amount * 30.4167).toFixed(0);
    }
}

function processPriceEstimation(response) {
    var locationFull = document.querySelector('[name=location_full]').value.split(',');
    var locationName = locationFull[0];
    var numberOfBedrooms = parseInt(document.querySelector('[name=rooms]').value);

    var priceCalcDiv = document.getElementById("price-calc");
    priceCalcDiv.innerHTML = "";


    // initialize the currencies dropdown menu
    var selectCurrency = document.createElement("select");
    selectCurrency.id = "currencySelect";

    var currencyIndex = 0; // we need that variable in order to pre-select one currency
    var preselectedCurrency = ""; // we also keep track of that preselected currency
    for (var key in response.response.currencies) {
        if (response.response.currencies[key].adrLtm_converted !== null && !(response.response.currencies[key].adrLtm_converted < 1)) {
            var k = document.createElement("option");
            k.setAttribute("value", key);

            if (currencyIndex === 0) {
                k.setAttribute("selected", true);
                preselectedCurrency = key;
                currencyIndex++;
            }
            var kText = document.createTextNode(response.response.currencies[key].adrLtm_converted.currencySymbol);
            k.appendChild(kText);
            selectCurrency.appendChild(k);
        }
    }

    priceCalcDiv.innerHTML =
        "" +
        "<h2>Average price for " + numberOfBedrooms + ' bedroom in ' + locationName + ' is around:</h2>' +
        '<div class="result">' +
        '<span id="convertedPrice">' +
        '<span id="currencySymbolId">' + (preselectedCurrency === "usd" ? '$' : response.response.currencies[preselectedCurrency].adrLtm_converted.currencySymbol) + '</span>' +
        '<span id="convertedPriceValue">' + parseFloat(preselectedCurrency === "usd" ? response.response.adrLtm : response.response.currencies[preselectedCurrency].adrLtm_converted.convertedAmount).toFixed(0) +
        '</span></span>' +
        '<span id="selectPeriod" class="selectWrap"></span>' +
        '<span class="currency selectWrap" id="selectCurrencies"> ' +
        (preselectedCurrency === "usd" ? '$' : response.response.currencies[preselectedCurrency].adrLtm_converted.currencySymbol) +
        '</span>' +
        '</div>' +
        '<p class="small">Price is an estimate only, based on a real estate algorithm.<br>A full review will be carried out by our revenue manager after our visit.</p>' +
        '';

    storeEstimatedPricesForEmailTemplate(response, preselectedCurrency);

    // we add also the usd currency
    // its an independent process since we de-couple the currency exchanger and we use the returned USD value from AirDNA. 
    // with that way, is the currency exchange fails, we can still show the usd
    var kDollarOption = document.createElement("option");
    kDollarOption.setAttribute("value", "usd");
    var kDollarText = document.createTextNode("$");
    kDollarOption.appendChild(kDollarText);
    selectCurrency.appendChild(kDollarOption);

    selectCurrency.onchange = function() {
        var select = document.getElementById("dayWeekMonthSelect").selectedIndex;

        if (selectCurrency.selectedIndex === 0) { // gbp
            var priceDayGbp = document.getElementById("convertedPriceValue");
            priceDayGbp.innerHTML = returnCalculatedPrice(select, response.response.currencies.gbp.adrLtm_converted.convertedAmount);
            storeEstimatedPricesForEmailTemplate(response, 'gbp');

        } else if (selectCurrency.selectedIndex === 1) { // aed
            var priceDayAed = document.getElementById("convertedPriceValue");
            priceDayAed.innerHTML = returnCalculatedPrice(select, response.response.currencies.aed.adrLtm_converted.convertedAmount);
            storeEstimatedPricesForEmailTemplate(response, 'aed');

        } else if (selectCurrency.selectedIndex === 2) { // eur
            var priceDayEur = document.getElementById("convertedPriceValue");
            priceDayEur.innerHTML = returnCalculatedPrice(select, response.response.currencies.eur.adrLtm_converted.convertedAmount);
            storeEstimatedPricesForEmailTemplate(response, 'eur');

        } else if (selectCurrency.selectedIndex === 3) { // usd
            var priceDayUsd = document.getElementById("convertedPriceValue");
            priceDayUsd.innerHTML = returnCalculatedPrice(select, response.response.adrLtm);
            storeEstimatedPricesForEmailTemplate(response, 'usd');
        }
        var a = document.getElementById("currencySymbolId").innerHTML = (selectCurrency.selectedIndex === 3 ? '$' : response.response.currencies[currencyIndexes[selectCurrency.selectedIndex]].adrLtm_converted.currencySymbol);

    };


    // initialize the dropdown menu for day week month
    var periodSpan = document.getElementById("selectPeriod");
    periodSpan.innerHTML = '<select id="dayWeekMonthSelect"><option value="day" selected="true">daily</option><option value="week">weekly</option><option value="month">monthly</option></select>';

    var select = document.getElementById("dayWeekMonthSelect");

    select.onchange = function() {
        selectedCurrencyIndex = parseInt(document.getElementById("currencySelect").selectedIndex);
        var convPriceEl = document.getElementById("convertedPriceValue"),
            dailyAmount;
        if (selectedCurrencyIndex === 3) { // first check if we have our fallback, which is USD
            dailyAmount = parseFloat(response.response.adrLtm).toFixed(0);
        } else {
            dailyAmount = parseFloat(response.response.currencies[currencyIndexes[selectedCurrencyIndex]].adrLtm_converted.convertedAmount).toFixed(0);
        }
        convPriceEl.innerHTML = returnCalculatedPrice(select.selectedIndex, dailyAmount);
        var a = document.getElementById("currencySymbolId").innerHTML = (selectedCurrencyIndex === 3 ? '$' : response.response.currencies[currencyIndexes[selectedCurrencyIndex]].adrLtm_converted.currencySymbol);

    };

    var currencySpan = document.getElementById("selectCurrencies");
    currencySpan.innerHTML = "";
    currencySpan.appendChild(selectCurrency);

}

function getPriceEstimation() {
    window.currencyIndexes = {
        '0': 'gbp',
        '1': 'aed',
        '2': 'eur'
    };
    var div = document.getElementById("price-calc");

    if (div !== null) {
        // set values of emptied form fields (bug of contact form 7?)
        document.querySelector('[name=email]').value = document.querySelector('[name=email]').getAttribute('value');
        document.querySelector('[name=rooms]').value = document.querySelector('[name=rooms]').getAttribute('value');
        document.querySelector('[name=location_array]').value = document.querySelector('[name=location_array]').textContent;
        // document.querySelector('[name=email]').value = document.querySelector('[name=location_array]').getAttribute('value');

        // get the element with the locations
        var locationArr = document.querySelector('[name=location_array]').textContent.split('\n');
        if (locationArr.length < 3) {
            return;
        }
        // parse latitude and longitude and round them to 6 digits
        var lat = parseFloat(locationArr[locationArr.length - 2].substring(5, locationArr[locationArr.length - 2].length)).toFixed(5);
        var lon = parseFloat(locationArr[locationArr.length - 1].substring(5, locationArr[locationArr.length - 1].length)).toFixed(5);

        var locationFull = document.querySelector('[name=location_full]').value.split(',');
        var locationName = locationFull[0];

        // create a header
        var initMessage = document.createElement("div");
        initMessage.innerHTML = "<h4>Just a few seconds...</h4><p>We are checking how much you could earn</p>";

        div.appendChild(initMessage);

        var parameters = {
            'address': lat + ', ' + lon,
            'nrBedrooms': parseInt(document.querySelector('[name=rooms]').value),
            'nrBathrooms': 1,
            'nrPeople': 2,
            'currency': 'gbp',
            'markup': markup
        };

        var xmlhttp = new XMLHttpRequest();

        xmlhttp.open("GET", (location.host === 'localhost' ? '/airbetter/' : '') + "/php/priceEstimator.php" + formatParams(parameters));
        xmlhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xmlhttp.send();

        xmlhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                // parse the response to JSON

                var response = JSON.parse(this.responseText);

                var booleanValidation = validateResponse(response);

                if (!booleanValidation) {
                    processNonCoveredArea(locationArr);

                } else {
                    processPriceEstimation(response);

                }
            }
        };
    }
}


(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages
                loadYoutubePlayer('youtube-player');

                // lazy load elements
                jQuery('.lazy').lazy({
                    effect: "fadeIn",
                    googleMapsLoader: function(element) {
                        var frame = $('<iframe />');
                        frame.attr({
                            'frameborder': 0,
                            'src': element.data("src"),
                            'allowfullscreen': 1
                        });
                        element.prepend(frame).load();
                    },
                    afterLoad: function(element) {
                        $(element).removeClass('loading');
                    }
                });

                // sticky menu
                $win = $(window);
                $body = $(document.body);
                $win.scroll(throttle(function() {
                    if ($win.scrollTop() > 0) {
                        $body.addClass('scroll');
                    } else {
                        $body.removeClass('scroll');
                    }
                }, 150));

                var body = $("html, body"),
                    menuHeigth = 62;
                $('.header-title .down').click(function(e) {
                    e.preventDefault();
                    body.stop().animate({
                        scrollTop: $('.banner').height() - menuHeigth
                    }, 400, 'swing');
                });

                if ($('#price-calc').length) {
                    getPriceEstimation();
                }
            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
                addPropertyValidation();
                if ($('#contact-date').length) {
                    var now = new Date();
                    var day = ("0" + now.getDate()).slice(-2);
                    var month = ("0" + (now.getMonth() + 1)).slice(-2);
                    var today = now.getFullYear() + "-" + (month) + "-" + (day);
                    $('#contact-date').val(today);
                }

            }
        },
        // Home page
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
                jQuery('a[data-target="#requestform"]').click(function() {
                    window.setTimeout(function() {
                        $("html, body").stop().animate({
                            scrollTop: $('#requestform').position().top
                        }, 400, 'swing');
                    }, 400);
                });
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                // JavaScript to be fired on the about us page
            }
        },
        'splash': {
            init: function() {
                // window.console.log(jQuery('a[data-target="#requestform"]'));
                // jQuery('a[data-target="#requestform"]').click(function() {
                //   window.console.log('click');
                //   body.stop().animate({scrollTop: $('#requestform').position().top}, 400, 'swing');
                // });
                // jQuery('[name="check-in-date"]').change(function() {
                //   if (!jQuery('[name="check-out-date"]').val()) {
                //     var checkout = new Date(jQuery('[name="check-in-date"]').val());
                //     checkout.setDate(checkout.getDate() + 1);
                //     jQuery('[name="check-out-date"]').val(formatDate(checkout));
                //   }
                // });
                // jQuery('#slides').superslides(splashSlidesOptions);
            }
        },
        'gallery': {
            init: function() {
                jQuery('#justified-gallery').justifiedGallery({
                    rowHeight: 300,
                    lastRow: 'justify',
                    margins: 0,
                    waitThumbnailsLoad: false,
                    thumbnailPath: function(currentPath, width, height, image) {

                        // window.console.log(currentPath);
                        if (typeof $(image).data('jg-srcset') === 'undefined') {
                            return currentPath;
                        }
                        // debug = true;
                        // var debug = (currentPath.indexOf('Sumba_Nihi_250') !== -1);
                        var srcset = $(image).data('jg-srcset');
                        if ($(image).length > 0 && srcset.length > 0) {
                            var path, sizes = [],
                                sizesTemp = [],
                                urls = srcset.split(","),
                                bestMatchIndex = -1;
                            if (urls.length > 0) {
                                for (i = 0; i < urls.length; i++) {
                                    var url, sizeW, item = urls[i].trim().split(" ");
                                    if (typeof item[0] !== 'undefined' && typeof item[1] !== 'undefined') {
                                        sizeW = item[1].replace('w', '');
                                        sizesTemp[sizeW] = {
                                            width: parseInt(item[1].replace('w', '')),
                                            url: item[0]
                                        };
                                    }
                                }
                                for (i = 0; i < sizesTemp.length; i++) {
                                    if (sizesTemp[i]) {
                                        sizes.push(sizesTemp[i]);
                                    }
                                }
                                // if (debug) { console.log(sizes); }
                            }
                            for (i = 0; i < sizes.length; i++) {
                                if (sizes[i].width >= width && (bestMatchIndex === -1 || sizes[i].width <= sizes[bestMatchIndex].width)) {
                                    bestMatchIndex = i;
                                }
                            }
                            // console.log('request: '+width+'  return: '+sizes[bestMatchIndex].width);
                            // $(image).attr('src', sizes[bestMatchIndex].url);
                            return bestMatchIndex === -1 ? sizes[0].url : sizes[bestMatchIndex].url;
                            // return currentPath;
                        } else {
                            return currentPath;
                        }
                    }
                });
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.